import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-wams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-wams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { CreateApplicationLocationWamsConstants } from "./create-application-location-wams.constants";
import { MapTools } from "../../../../map/shared/map.tools";
import GeometryUtils from "../../../../shared/utils/geometry-utils";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
export let CreateApplicationLocationWamsComponent = class CreateApplicationLocationWamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    mapTools;
    changeDetectorRefs;
    active;
    locationForm;
    descriptionLabel1 = CreateApplicationLocationWamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationWamsConstants.DESCRIPTION_LABEL_2;
    layerReference = CreateApplicationLocationWamsConstants.LAYER_REF;
    showOnlyPropertyAndZoningLayers = false;
    mapComponent;
    sketch;
    selectedGraphic = null;
    isMapLoaded = false;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, mapTools, changeDetectorRefs) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.setupSubscribers();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.sketch = this.mapTools.getMapTool("drawTool");
        this.mapTools.expandWidget("drawTool");
        this.sketch.create("polygon");
        this.sketch.on("create", (event) => {
            if (event.state === "complete") {
                this.selectedGraphic = event.graphic;
                this.locationForm.get("selectedGraphic").setValue(this.selectedGraphic);
                if (event.graphic.geometry.type === "point") {
                    this.locationForm.get("centroid").setValue(event.graphic.geometry);
                    this.locationForm.get("polygon").setValue(null);
                    this.locationForm.get("polyline").setValue(null);
                }
                else {
                    const proxyUrl = ApiProxyConstants.URL;
                    const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                    const url = `${proxyUrl}?${gpToolUrl}`;
                    const formData = new FormData();
                    formData.append("f", "json");
                    formData.append("geometryJSON", JSON.stringify(event.graphic.geometry));
                    this.applicationCreateService.getTrueCentroid(url, formData)
                        .subscribe((trueCentroidResponse) => {
                        this.locationForm.get("centroid").setValue(trueCentroidResponse.results[0].value);
                        this.locationForm.markAsTouched();
                        if (event.graphic.geometry.type === "polygon") {
                            this.locationForm.get("polygon").setValue(event.graphic.geometry);
                        }
                        else if (event.graphic.geometry.type === "polyline") {
                            this.locationForm.get("polyline").setValue(event.graphic.geometry);
                        }
                    }, (error) => {
                        this.appController.handleServerErrorMessage(CreateApplicationLocationWamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    });
                }
            }
            else if (event.state !== "cancel") {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
        if (this.locationForm.get("selectedGraphic").value !== null) {
            this.selectedGraphic = this.locationForm.get("selectedGraphic").value;
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.selectedGraphic.geometry)], "Draw Tool Layer");
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    loadMetadata(stepMeta) {
    }
    syncMapGeometries() {
        const geometries = [];
        if (this.selectedApplication !== undefined && this.selectedApplication !== null) {
            if (this.selectedApplication.applicationLines !== null && this.selectedApplication.applicationLines.length > 0) {
                geometries.push(this.locationForm.get("polyline").value);
            }
            else if (this.selectedApplication.applicationPolygons !== null && this.selectedApplication.applicationPolygons.length > 0) {
                geometries.push(this.locationForm.get("polygon").value);
            }
            else {
                geometries.push(this.locationForm.get("centroid").value);
            }
            if (geometries.length > 0) {
                this.mapComponent.addGeometriesOnMap(geometries, "Draw Tool Layer", true);
            }
            else {
                this.mapComponent.removeGraphicsFromMap("Draw Tool Layer");
            }
        }
    }
    subscribeToClearMapGraphics() {
        this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    setMapData() {
        const centroidGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.shape, 102100);
        const centroid = JsonUtils.fromJSON(centroidGeometryArc);
        const geometries = [];
        this.locationForm.get("centroid").setValue(centroid);
        let showPoint = true;
        if (this.selectedApplication.applicationPolygons.length > 0) {
            showPoint = false;
            const polygonGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.applicationPolygons[0].shape, 102100);
            const polygon = JsonUtils.fromJSON(polygonGeometryArc);
            this.locationForm.get("polygon").setValue(polygon);
            this.locationForm.get("polygonDto").setValue(this.selectedApplication.applicationPolygons[0]);
            geometries.push(polygon);
        }
        else {
            this.locationForm.get("polygon").setValue(null);
            this.locationForm.get("polygonDto").setValue(null);
        }
        if (this.selectedApplication.applicationLines.length > 0) {
            showPoint = false;
            const polylineGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.applicationLines[0].shape, 102100);
            const polyline = JsonUtils.fromJSON(polylineGeometryArc);
            this.locationForm.get("polyline").setValue(polyline);
            this.locationForm.get("polylineDto").setValue(this.selectedApplication.applicationLines[0]);
            geometries.push(polyline);
        }
        else {
            this.locationForm.get("polyline").setValue(null);
            this.locationForm.get("polylineDto").setValue(null);
        }
        if (showPoint) {
            geometries.push(centroid);
        }
        this.mapComponent.addGeometriesOnMap(geometries, "Wayleave graphics", true);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("locationForm");
        this.locationForm = form;
    }
    setupSubscribers() {
        this.subscribeToClearMapGraphics();
        this.subscribeToSelectedApplication();
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe({
            next: (application) => {
                this.selectedApplication = +this.jobId > 0 && application ? application : null;
                if (this.selectedApplication) {
                    this.setMapData();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: MapTools },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationWamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-wams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationLocationWamsComponent);
